import api from "./axiosInstance";

/**
 * Estimate/Quotation API Service
 * Handles all estimate/quotation related API calls
 * Backend: EstimateController at /api/v1/estimates
 */

export const estimateApi = {
  /**
   * Get all estimates
   * GET /api/v1/estimates
   */
  getAllEstimates: (params = {}) => {
    return api.get("estimates", { params });
  },

  /**
   * Get estimate by ID
   * GET /api/v1/estimates/{id}
   */
  getEstimateById: (id) => {
    return api.get(`estimates/${id}`);
  },

  /**
   * Create new estimate
   * POST /api/v1/estimates
   */
  createEstimate: (data) => {
    return api.post("estimates", data);
  },

  /**
   * Update estimate
   * PUT /api/v1/estimates/{id}
   */
  updateEstimate: (id, data) => {
    return api.put(`estimates/${id}`, data);
  },

  /**
   * Patch estimate
   * PATCH /api/v1/estimates/{id}
   */
  patchEstimate: (id, data) => {
    return api.patch(`estimates/${id}`, data);
  },

  /**
   * Delete estimate by ID
   * DELETE /api/v1/estimates/{id}
   */
  deleteEstimate: (id) => {
    return api.delete(`estimates/${id}`);
  },

  /**
   * Get next quotation number
   * GET /api/v1/estimates/next-number
   */
  getNextQuotationNumber: () => {
    return api.get("estimates/next-number");
  },

  /**
   * Get statistics
   * GET /api/v1/estimates/statistics
   */
  getStatistics: () => {
    return api.get("estimates/statistics");
  },

  /**
   * Convert estimate to invoice
   * POST /api/v1/estimates/{id}/convert
   */
  convertEstimate: (id, data = {}) => {
    return api.post(`estimates/${id}/convert`, data);
  },

  /**
   * Send estimate via email
   * POST /api/v1/estimates/{id}/send
   */
  sendEstimate: (id, data = {}) => {
    return api.post(`estimates/${id}/send`, data);
  },

  /**
   * Download estimate PDF
   * GET /api/v1/estimates/{id}/pdf
   */
  downloadEstimatePdf: (id) => {
    return api.get(`estimates/${id}/pdf`, { responseType: 'blob' });
  },

  /**
   * Preview estimate PDF
   * GET /api/v1/estimates/{id}/preview
   */
  previewEstimatePdf: (id) => {
    return api.get(`estimates/${id}/preview`, { responseType: 'blob' });
  }
};

export default estimateApi;